import PageHeader from "../components/PageHeader";
import { Button } from "@/components/ui/button";
import { SIGNUP_URL } from "../lib/site";
import { Heart, Target, Users } from "lucide-react";

const values = [
  { icon: Heart, t: "Community-first", d: "Built by people who send money home themselves. The pain points are personal." },
  { icon: Target, t: "Radically transparent", d: "Every rate, every margin, every step. No hidden fees. No surprises." },
  { icon: Users, t: "Built for the diaspora", d: "Tailored to the Nigerian-Canadian community — not a generic global tool." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow="About us"
        title="A Naira–CAD specialist built by the diaspora, for the diaspora."
        subtitle="CashPark Inc was founded to give Nigerian-Canadians a fair, fast, and transparent way to move money between Canada and Nigeria."
      />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="prose-blog">
          <h2>Our story</h2>
          <p>Like so many in the Nigerian-Canadian community, our founders sent money home and watched a chunk vanish into hidden bank margins and intermediary fees. We built CashPark to fix that — a specialist platform focused on a single corridor, with rates and margins shown openly.</p>
          <h2>Our mission</h2>
          <p>To make every Naira–CAD transfer transparent, fast, and fairly priced — so more of your money lands where it should.</p>
          <h2>What we don't do</h2>
          <p>We don't pretend to be a global money transfer giant. We're not trying to be 30+ corridors. We do one route, and we do it better than generalists ever can.</p>
        </div>

        <div className="grid sm:grid-cols-3 gap-5 mt-12">
          {values.map((v) => (
            <div key={v.t} className="rounded-2xl border border-slate-200 p-6" data-testid={`value-${v.t.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className="w-10 h-10 rounded-xl bg-orange-50 text-[#FF6B00] flex items-center justify-center">
                <v.icon size={20} />
              </div>
              <h3 className="font-display font-semibold text-lg text-[#0B192C] mt-4">{v.t}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-3xl bg-[#0B192C] p-10 text-white text-center">
          <h3 className="font-display text-2xl sm:text-3xl font-bold">Join thousands sending smarter.</h3>
          <a href={SIGNUP_URL} target="_blank" rel="noopener noreferrer" data-testid="about-signup-button" className="inline-block mt-6">
            <Button className="rounded-full bg-[#FF6B00] hover:bg-[#E65C00] h-12 px-7 font-semibold">Create your account</Button>
          </a>
        </div>
      </section>
    </div>
  );
}
